import React, { useEffect, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';


export default function Loading() {
    return (
        <>
            <Container fluid className='text-center pt-5 text-muted'>
                {LanguageProvider.get('defaults.loading')}... <Spinner size="sm" />
            </Container>
        </>
    );
};